import Select, { SelectProps } from '@mui/material/Select';
import { VIEW_MODE } from '../../consts/enums';
import style from './style';

type CustomSelectProps = SelectProps & {
  viewMode?: ViewMode,
};

const CustomSelect = ({
  viewMode,
  ...muiProps
}: CustomSelectProps): JSX.Element | null => {
  const isReadOnly = viewMode === VIEW_MODE.READ_ONLY;

  const combinedProps = {
    ...muiProps,
    ...(isReadOnly) && {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      IconComponent: () => null,
      disabled: true,
      disableUnderline: true,
      sx: { ...muiProps.sx, ...style.disabledInput },
    },
  };

  if (viewMode === VIEW_MODE.HIDDEN) {
    return null;
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Select { ...combinedProps } />
  );
};

CustomSelect.defaultProps = {
  viewMode: VIEW_MODE.READ_ONLY,
};

export default CustomSelect;
